import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import LogoutIcon from "@mui/icons-material/Logout";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { callAPI } from "../../../axios";
import { getChainIdLS, isValidRole, ScrollToTop } from "../../../utils/utils";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { MdModeEditOutline } from "react-icons/md";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import CdsnsListMapping from "./CdsnsListMapping";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ImageResolutionTooltip from "./ImageResolutionTooltip";
import "./UploadApk.scss";

const APK_STATUS = {
    IN_PROGRESS: 'Validation In Progress',
    VALIDATED: 'Validated',
    VALIDATED_FAILED: 'Validation Failed',
    READY_FOR_TARGETING : "Ready for Targeting",
    EXTRACTION_FAILED: 'APK Extraction Failed',
};


const UploadApk = (props) => {
    let userRoleCode = JSON.parse(localStorage.getItem("userDetails"))?.roles[0]?.roleCode;
    let { viewType, setLoader, hotelDetails, createUpdateFlag, disableAPKFlag } = props;
    const [uploadApkList, setUploadApkList] = useState([]);
    const [editHotel, setEditHotel] = useState(false);
    const [editHotelSid, setEditHotelSid] = useState("");
    const [editHotelUpdate, setEditHotelUpdate] = useState(false);
    const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
    const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState('');
    const [confirmDeleteHotel, setConfirmDeleteHotel] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [confirmAPICall, setConfirmAPICall] = useState(false);
    const [confirmAPICalling, setConfirmAPICalling] = useState(false);
    const [uploadedApkUrl, setUploadedApkUrl] = useState('');
    const [apkCreateUpdateFlag, setAPKCreateUpdateFlag] = useState(false);
    const [packageMasterList, setPackageMasterList] = useState([])

    const [totalApkCountFlag, setTotalApkCountFlag] = useState(false)

    const [activityNameMaster, setActivityNameMaster] = useState([]);
    const [extractedPackageName, setExtractedPackageName] = useState(null);
    const [extractedVersion, setExtractedVersion] = useState(null);
    const [initialEditValues, setInitialEditValues] = useState(null);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        control,
        setValue,
        setError,
        clearErrors,
    } = useForm({
        mode: 'onChange',
    });
    const watchedApkName = watch('apkName');
    const watchedAppVersions = watch('appVersions');
    const watchedActivityName = watch('activityName');
    const watchedUploadFile = watch('uploadFile');
    const hasEditChanges = initialEditValues && (String(watchedApkName ?? '').trim() !== initialEditValues.apkName || String(watchedAppVersions ?? '').trim() !== initialEditValues.appVersions || String(watchedActivityName ?? '').trim() !== initialEditValues.activityName || !!watchedUploadFile?.[0]);
    const isPackageAndVersionDisabled = editHotelUpdate && editHotelSid?.status === APK_STATUS.VALIDATED;

    const { chainId } = useSelector((state) => state.chainIdReducer);
    let validPermissionClassName = isValidRole("HOTEL_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

    const iHCLAPKFile = [
        {
          name: "IHCL APK File",
          files: 1,
          size: "70 MB",
          formats: "APK",
        }
      ]

    const onSubmit = (data) => {
        if (confirmAPICall && confirmAPICalling===false) {
            setConfirmAPICalling(true);
            return;
        }
        clearErrors(['apkName', 'appVersions', 'root']);
        if (editHotelUpdate && initialEditValues && String(data?.apkName ?? '').trim() === initialEditValues.apkName && String(data?.appVersions ?? '').trim() === initialEditValues.appVersions && String(data?.activityName ?? '').trim() === initialEditValues.activityName && !data?.uploadFile?.[0]) {
            setError('root', { type: 'manual', message: 'No changes to update.' });
            return;
        }
        if (editHotelUpdate && (extractedPackageName != null || extractedVersion != null)) {
            if (extractedPackageName != null && String(data?.apkName ?? '').trim() !== String(extractedPackageName).trim()) {
                setError('apkName', { type: 'manual', message: `Package mismatch: File uploaded has package name '${extractedPackageName}'` });
                return;
            }
            if (extractedVersion != null && String(data?.appVersions ?? '').trim() !== String(extractedVersion).trim()) {
                setError('appVersions', { type: 'manual', message: `APK version mismatch: File uploaded has version '${extractedVersion}'` });
                return;
            }
            
        }
        const formData = new FormData();
        if (data.uploadFile[0]) {
            formData.append('apkFile', data.uploadFile[0]);
        }
        setConfirmAPICalling(false);
        let method = "PUT";
        let url = `/hotel/upload/apk?apkName=${data?.apkName}&version=${data?.appVersions}&activityName=${data?.activityName==="NA"?"":data?.activityName}`;
        if (editHotelUpdate) {
            url = `/hotel/upload/apk?apkId=${editHotelSid?.id}&apkName=${data?.apkName}&version=${data?.appVersions}&activityName=${data?.activityName==="NA"?"":data?.activityName}`;
        }
        setLoader(true);
        callAPI(url, method, formData, { chainId: getChainIdLS() })
            .then(function (response) {
                setCreateHotelSuccessMsg(response?.message);
                setExtractedPackageName(null);
                setExtractedVersion(null);
                setInitialEditValues(null);
                reset({
                    apkName: '',
                    appVersions: '',
                    uploadFile: '',
                    activityName:''
                });
                setUploadedApkUrl('');
                uploadApkListApi();
                setEditHotelSid('');
                setEditHotel(false);
                setLoader(false);
                setAPKCreateUpdateFlag((prev) => !prev);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    };

    const approveUploadedApk = (data)=>{
        setLoader(true);
        let method = "PUT";
        let url = `/hotel/confirmUpload/apk?apkId=${data?.id}&version=${data?.extractedVersion}`;
        callAPI(url, method, {}, {})
            .then(function (response) {
                setLoader(false);
                uploadApkListApi();
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

const renderAPKActionIcon = (row) => {
        const rowStatus =  row?.status || "Ready for Targeting"
        const apkSignatureFailed = (rowStatus === APK_STATUS.VALIDATED_FAILED) && row?.apkName === row?.extractedPackageName && row?.version === row?.extractedVersion;
        return (
            isValidRole("HOTEL_CONFIGURATION_MODIFY")?<>
                <Tooltip title="Edit" arrow>
                    <span><MdModeEditOutline
                        className={rowStatus === APK_STATUS.IN_PROGRESS || rowStatus === APK_STATUS.READY_FOR_TARGETING || rowStatus === APK_STATUS.EXTRACTION_FAILED || apkSignatureFailed   ? 'edit-icon-disable' : "edit-icon-enable"}
                        onClick={() => { 
                            if(!(rowStatus === APK_STATUS.IN_PROGRESS || rowStatus === APK_STATUS.READY_FOR_TARGETING || rowStatus === APK_STATUS.EXTRACTION_FAILED || apkSignatureFailed)){
                            setEditHotel(true); 
                            setEditHotelSid(row) 
                            }
                        }}
                    /></span>
                </Tooltip>
                <Tooltip title="Delete" className="cursor-pointer" arrow>
                     <DeleteIcon
                        className={rowStatus === APK_STATUS.IN_PROGRESS ? 'delete-icon-disable' : "delete-icon-enable"}
                        onClick={() => rowStatus === APK_STATUS.IN_PROGRESS ? null:  deleteHotelPopUpHandler(row) }
                    />
                </Tooltip>
                <Tooltip title="Confirm" className="cursor-pointer" arrow>
                    <CheckIcon
                        className={rowStatus === APK_STATUS.VALIDATED ? "approve-icon-enable" : 'approve-icon-disable'}
                        onClick={() => rowStatus === APK_STATUS.VALIDATED ? approveUploadedApk(row) : null }
                    />
                </Tooltip>
            </>:
            <>
            <Tooltip title="Don't have permission to edit" arrow>
            <span>
                <MdModeEditOutline className="edit-icon-disable" />
            </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete" arrow>
            <DeleteIcon className="delete-icon-disable" />
            </Tooltip>
        </>
        );
    };

    const handleGetErrorMsg = (version = '', extractedVersion = '', apkName = '', extractedPackageName = '', status) => {
        let errMsg = ""
        if(status === APK_STATUS.EXTRACTION_FAILED){
           return "Uploaded APK could not be validated. Please delete and re-upload a correct APK file."
        }
        if (apkName !== extractedPackageName) {
            errMsg += `Package mismatch: File uploaded has package name '${extractedPackageName}'`
        }
        if (version !== extractedVersion) {
            errMsg += `${errMsg ? '\n':''}APK version mismatch: File uploaded has version '${extractedVersion}'`
        }

        return errMsg || 'APK signature verification failed. Please contact with support team.'
    }

    const hotelColumns = [
        { field: "createdOn", headerName: "Date & Time", flex: 1, row: true, renderCell: (row)=> <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
        { field: "apkName", headerName: "Package Name", flex: 1 },
        { field: "version", headerName: "APK Version Code", flex: 1 },
        { field: "status", headerName: "Status", flex: 1, row: true,         renderCell: (row) => {
            const status = row?.status ?? "Ready for Targeting";
            const errMsg = handleGetErrorMsg(row?.version, row?.extractedVersion, row?.apkName, row?.extractedPackageName, status)
            return (
                <p className="mb-0 gap-1 flex-item ">
                    <span>
                        {status}
                    </span>
                    {(status === APK_STATUS.VALIDATED_FAILED || status === APK_STATUS.EXTRACTION_FAILED) && <Tooltip componentsProps={{
                        tooltip: {
                            sx: { whiteSpace: 'pre-line' }
                        }
                    }} title={errMsg} arrow>
                        <span className="cursor-pointer d-inline-flex align-items-center" aria-label="Validation info">
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "#5e03c7" }} />
                        </span>
                    </Tooltip>}
                </p>
            );
        } },
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.8,
            renderCell: renderAPKActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    const uploadApkListApi = () => {
        callAPI(`/hotel/upload/apk/all`, "GET", {}, { chainId: getChainIdLS() })
            .then((response) => {
                const sortedResponse = response?.sort((a,b)=>a.createdOn-b.createdOn)
                setUploadApkList(sortedResponse)
                setTotalApkCountFlag(response?.length>0?false:true)
            })
            .catch((err) => console.warn(err.message));
    };

    useEffect(()=>{
            callAPI(`/package-activity`, "GET", {}, { chainId: getChainIdLS() })
                .then((response) => {
                    setPackageMasterList(response)
                })
                .catch((err) => console.warn(err.message));
    },[chainId])

    useEffect(()=>{
        reset({
            apkName: '',
            appVersions: '',
            uploadFile: '',
            activityName:''
        });
    },[chainId])

    useEffect(() => {
        uploadApkListApi();
     }, [createUpdateFlag,chainId]);

    useEffect(() => {
        if (initialEditValues && hasEditChanges) clearErrors('root');
    }, [watchedApkName, watchedAppVersions, watchedActivityName, watchedUploadFile]);

    useEffect(() => {
        if (editHotelSid) {
            getHotelListSidHandler();
        }
        ScrollToTop();
    }, [editHotelSid]);

    const getHotelListSidHandler = () => {
        callAPI(`/hotel/upload/apk?sid=${editHotelSid?.id}`, "GET")
            .then(function (response) {
                const payload = {
                    apkName: response?.apkName,
                    appVersions: response?.version,
                    activityName: response?.activityName?response?.activityName:"NA",
                    uploadFile: '',
                };
                const filteredActivityName = packageMasterList?.filter(item=>item.packageName===response?.apkName)
                if(filteredActivityName.length){
                    setActivityNameMaster(packageMasterList?.filter(item=>item.packageName===response?.apkName)[0]?.activityNames)
                }
                setUploadedApkUrl(response?.fileName);
                if (response?.extractedPackageName != null) {
                    setExtractedPackageName(response.extractedPackageName);
                } else {
                    setExtractedPackageName(null);
                }
                if (response?.extractedVersion != null) {
                    setExtractedVersion(response.extractedVersion);
                } else {
                    setExtractedVersion(null);
                }
                reset(payload);
                setInitialEditValues({ apkName: String(payload.apkName ?? '').trim(), appVersions: String(payload.appVersions ?? '').trim(), activityName: String(payload.activityName ?? '').trim() });
                setEditHotelUpdate(true);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
            });
    }

    const cancelHotelHandler = () => {
        setExtractedPackageName(null);
        setExtractedVersion(null);
        setInitialEditValues(null);
        reset({
            apkName: '',
            appVersions: '',
            uploadFile: '',
            activityName: '',
        });
        setActivityNameMaster([])
        setUploadedApkUrl('');
        setEditHotelUpdate(false);
        setEditHotelSid('');
        setEditHotel(false);
    }

    const resetLayoutHandler = () => {
        reset();
    }
    const popupCloseHandler = () => {
        setDeleteHotelPopUp(false);
    };
    const isHotelDeletedRef = useRef({
        isHotelDeletedModalData: null,
        userConformationModalData: null,
    });

    const deleteHotelPopUpHandler = (row) => {
        setDeleteHotelPopUp(true);
        const newModalRefData = {
            isHotelDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isHotelDeletedRef.current = newModalRefData;
    }

    const deleteHotelHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteHotel === "") {
            return
        }
        if (confirmDeleteHotel === `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}`) {
            setConfirmValidate(false)
            setLoader(true);
            const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
            callAPI(`/hotel/upload/apk?sid=${row?.id}`, "DELETE", {}, { chainId: getChainIdLS() })
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isHotelDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isHotelDeletedRef.current = newModalRefData;
                    uploadApkListApi();
                    setLoader(false);
                    setEditHotelSid('');
                    setAPKCreateUpdateFlag((prev) => !prev);
                    setExtractedPackageName(null);
                    setExtractedVersion(null);
                    setInitialEditValues(null);
                    reset({
                        apkName: '',
                        appVersions: '',
                        uploadFile: '',
                        activityName: '',
                    });
                    setActivityNameMaster([]);
                    setUploadedApkUrl('');
                    setEditHotelUpdate(false);
                    setEditHotel(false);
                })
                .catch((error) => {
                    console.warn(error);
                    setLoader(false);
                });
        }
        reset({
            apkName: '',
            appVersions: '',
            uploadFile: '',
        });
        setUploadedApkUrl('');
    }

    return (
        <>{(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp" && editHotel) &&
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
                <div className="row">
                    <div className="left-column-header">
                        <p>{editHotelUpdate ? 'Edit APK Details' : 'APK Details'}</p>
                    </div>
                    <div className="form-group-hotel col-6">
                    <div className="floating-select-label">
                        <Controller
                            name="apkName"
                            control={control}
                            rules={{
                            validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select Package Name',
                            }}
                            render={({ field }) => {
                                const selectedOption = packageMasterList.find(
                                    (option) => option.packageName === field.value
                                  );
                                  return (
                            <Autocomplete
                                {...field}
                                className={`multiselectlist ${selectedOption ? 'Mui-focused' : ''}`}
                                disablePortal
                                style={{backgroundColor: isPackageAndVersionDisabled ?  '#e6e6e6' : ''}}
                                disabled={isPackageAndVersionDisabled}
                                options={packageMasterList}
                                getOptionLabel={(option) => option?.packageName || ""}
                                onChange={(_, newValue) => {
                                field.onChange(newValue?.packageName ?? null);
                                setActivityNameMaster(Array.isArray(newValue?.activityNames) ? [...newValue.activityNames] : []);
                                }}
                                value={selectedOption || null}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder=""
                                    variant="outlined"
                                    label="Package Name"
                                    InputLabelProps={{
                                    shrink: false,
                                    }}
                                />
                                )}
                            />
                            )}}
                        />
                        {errors.apkName && (
                        <small className="required">{errors.apkName?.message}</small>
                        )}
                    </div>
                        {/* <div className={`floating-label`}>
                            <input
                                id="apkName"
                                maxLength={255}
                                placeholder=""
                                {...register("apkName", {
                                    required: "Please Enter Package ID",
                                })}
                            />
                            <label htmlFor="apkName">Enter Package ID</label>
                        </div>
                        {errors.apkName && (
                            <small className="required">{errors.apkName.message}</small>
                        )} */}
                    </div>
                    <div className="form-group-hotel col-6">
                        <div className={`floating-label`}>
                            <input
                                id="appVersions"
                                maxLength={25}
                                style={{backgroundColor: isPackageAndVersionDisabled ?  '#e6e6e6' : ''}}
                                placeholder=""
                                disabled={isPackageAndVersionDisabled}
                                {...register("appVersions", {
                                    required: "Please Enter APK Version",
                                    pattern: {
                                        value: /^[-+]?\d+$/,
                                        message: "Enter valid integers",
                                    },
                                })}
                            />
                            <label htmlFor="appVersions">Enter APK Version Code</label>
                        </div>
                        {errors.appVersions && (
                            <small className="required">{errors.appVersions.message}</small>
                        )}
                    </div>
                    <div className="form-group-hotel col-6">
                    <div className="floating-select-label">
                    <Controller
                        name="activityName"
                        control={control}
                        rules={{
                            validate: (value) =>
                            (value !== undefined && value !== null && value !== '') ||
                            'Please select Activity Name',
                        }}
                        render={({ field }) => {
                            const selectedOption = activityNameMaster.includes(field.value)
                            ? field.value
                            : null;

                            return (
                            <Autocomplete
                                className={`multiselectlist ${selectedOption ? 'Mui-focused' : ''}`}
                                disablePortal
                                options={activityNameMaster}
                                getOptionLabel={(option) => option || ''}
                                onChange={(_, newValue) => field.onChange(newValue)}
                                value={selectedOption}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Activity Name"
                                    InputLabelProps={{ shrink: false }}
                                />
                                )}
                            />
                            );
                        }}
                        />
                        {errors.activityName && (
                        <small className="required">{errors.activityName?.message}</small>
                        )}
                    </div>
                    </div>
                    {/* <div className="form-group-hotel col-6">
                        <div className={`floating-label`}>
                            <input
                                id="activityName"
                                maxLength={255}
                                placeholder=""
                                {...register("activityName", {
                                    required: "Please Enter Activity Name",
                                })}
                            />
                            <label htmlFor="activityName">Enter Activity Name</label>
                        </div>
                        {errors.activityName && (
                            <small className="required">{errors.activityName.message}</small>
                        )}
                    </div> */}

                 <div className={`third-party-hotel-app col-6 form-group-hotel flex-item`}>
                        <div className="flex-item">
                        <Tooltip title={`${editHotelUpdate ? 'To Update the APK file please create a new record' : 'Upload APK'}`} className="cursor-pointer me-2" arrow >
                            <input
                                type="file"
                                id="uploadFile"
                                hidden="hidden"
                                accept=".apk"
                                {...register("uploadFile", {
                                    required: editHotelSid ? false : "Please Upload APK File"
                                })}
                            />
                            <label htmlFor="uploadFile" className={`${editHotelSid ? 'opacity-50 flex-shrink-0' : ''} p-2`}>
                                <LogoutIcon className={`me-1 rotate-270`} /> Upload APK</label>
                        </Tooltip>
                        <ImageResolutionTooltip style={{ color: "#913aff" }} data={iHCLAPKFile} />
                        </div>
                        {editHotelUpdate ? <Tooltip title={uploadedApkUrl} className="cursor-pointer" arrow >
                            <p className="ms-3"><span>Uploaded Apk : </span>{uploadedApkUrl}</p></Tooltip> : <span className="ms-3">{watch('uploadFile') && watch('uploadFile')[0]?.name !== "" && watch('uploadFile')[0]?.name !== undefined ? `Selected APK : ${watch('uploadFile')[0]?.name}` : 'No file choosen, Yet'}</span>}
                        {errors.uploadFile && <p className="required mb-0">{errors.uploadFile.message}</p>}
                    </div>
                </div>
                <div className="col-12 form-group-hotel text-end">
                    {errors.root?.message && <small className="required d-block mb-2 text-start">{errors.root.message}</small>}
                    <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>Cancel</button>
                    {editHotelUpdate && <>
                        <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                    </>}
                    {editHotelUpdate && initialEditValues ? (
                        <Tooltip title={!hasEditChanges ? "No changes to update" : ""} arrow>
                            <span className="d-inline-block">
                                <button type="submit" className={`create-btn ${!hasEditChanges ? 'opacity-50 disabled' : ''}`} disabled={!hasEditChanges} style={!hasEditChanges ? { pointerEvents: 'none', cursor: 'not-allowed' } : undefined}>Update</button>
                            </span>
                        </Tooltip>
                    ) : (
                        <button type="submit" className="create-btn">{editHotelUpdate ? "Update" : "Upload"}</button>
                    )}
                </div>
            </form>}
            {(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp") && <div className="hotel-list">
                <div className="flex-items-between mb-3">
                    <p className="mb-0"><b>APK List</b></p>
                    <div className="d-flex align-items-center gap-2">
                        <Tooltip title="Refresh APK list" arrow>
                            <button
                                type="button"
                                className="create-btn d-inline-flex align-items-center justify-content-center p-2"
                                style={{ height: "35.19px" }}
                                onClick={() => uploadApkListApi()}
                                aria-label="Refresh"
                            >
                                <RefreshIcon sx={{ fontSize: 20 }} />
                            </button>
                        </Tooltip>
                        {isValidRole("HOTEL_CONFIGURATION_MODIFY")?<Tooltip title={`${uploadApkList.length >= 5 ? 'Maxmimum APK limit reached delete any record to proceed' : disableAPKFlag?"Please select APK Provider first to add new APK": 'Add New APK'}`} className="cursor-pointer" arrow>
                            <button disabled={disableAPKFlag} type="button" className={`create-btn ${(uploadApkList.length >= 5 || disableAPKFlag)  ? 'opacity-50' : ''}`} onClick={() => uploadApkList.length >= 5 ? '' : setEditHotel(true)}>Add New APK</button>
                        </Tooltip>:<Tooltip title="Don't have permission to add APK" arrow>
                            <span>
                            <button type="button" className={`create-btn ${validPermissionClassName}`}>Add New APK</button></span>
                        </Tooltip>}
                    </div>
                </div>
                <TableWrapper
                    data={uploadApkList}
                    columns={hotelColumns}
                    noPagination={true}
                    module='default'
                />
            </div>}
            {(viewType === "hotelApp" && userRoleCode !== "ROLE_SUPER_ADMIN") && <CdsnsListMapping totalApkCountFlag={totalApkCountFlag} viewType={viewType}  apkCreateUpdateFlag={apkCreateUpdateFlag} createUpdateFlag={createUpdateFlag}/>}
            <BasicModal
                popupOpen={createHotelSuccessMsg !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setCreateHotelSuccessMsg(''); setEditHotelUpdate(false); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            <BasicModal
                popupOpen={confirmAPICalling}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">Targeted CDSN is already being used in another APK Version. This action will overwrite the existing linking.</p>}
                footer={
                    {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: ()=>{setConfirmAPICalling(false);}
                        },
                        secondaryButton: {
                            buttonName: "Upload",
                            action:  ()=>{setConfirmAPICall(false); handleSubmit(onSubmit)()},
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            {deleteHotelPopUp && <BasicModal
                popupOpen={deleteHotelPopUp}
                bodyMessage={<>
                    <img src={deleteImg} alt="approve" className="w-40px" />
                    <div className="delete-hotel">{isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        <div className="confirm-delete-hotel">
                            <p>Do you really want to Delete APK " <b>{isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}</b> " ?</p>
                            <p className="warning"><IoMdWarning /> Warning</p>
                            <p>APK "{isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}" will be permanently deleted <br />
                                Deleting the specified APK can't be undone.
                            </p>
                            <p className="warning">Deleting the specific APK will impact CDSN mapping</p>
                            <p className="mt-3">To confirm deletion, type "Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}"</p>
                            <div className="form-group-hotel mt-3">
                                <div className="floating-label">
                                    <input
                                        id="deleteHotel"
                                        placeholder=""
                                        onChange={(e) => setConfirmDeleteHotel(e.target.value)}
                                    />
                                    <label htmlFor="address">Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}</label>
                                </div>
                                {(confirmDeleteHotel === "" && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}</small>
                                ) : (confirmDeleteHotel !== `${isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}` && confirmValidate) ? (
                                    <small className="d-block required text-start">Please Enter Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.apkName}</small>
                                ) : ""
                                }
                            </div>
                        </div> :
                        isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
                </>
                }
                footer={
                    isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Delete",
                                action: deleteHotelHandler
                            }
                        } : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler
                            }
                        }
                }
            />}
        </>
    )
}

export default UploadApk;